import React from 'react';
import { FormattedMessage } from 'react-intl';

import { InfoMark } from '@sharedComponents/InfoMark';
import { ReactFCV } from '@types';

import { messages } from '../../../messages';
import { FUND_RAISING_IMG_STORAGE } from '../../constants';

import { StyledFundRaisingTitle, StyledImage, StyledTitle } from './styled';

interface IFundRaisingTitleProps {
  image?: string | null;
  onClick: () => void;
}

export const FundRaisingTitle: ReactFCV<IFundRaisingTitleProps> = ({ image, onClick }) => (
  <StyledFundRaisingTitle onClick={onClick}>
    <StyledTitle>
      <FormattedMessage
        {...messages.fundRaiserTitle}
        values={{ icon: image ? <StyledImage url={`${FUND_RAISING_IMG_STORAGE}${image}`} /> : '' }}
      />
    </StyledTitle>
    <InfoMark content={<FormattedMessage {...messages.fundRaiserInfoBox} />} />
  </StyledFundRaisingTitle>
);
